import { ComponentTypes, Initiallocations } from "../../../config/config";
import { IFolderPanelInfo } from "../../../interfaces/IFolderPanelInfo";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { BaseFolderPanelHelper } from "./BaseFolderPanelHelper";
import { IFolderPanelHelper } from "../../../interfaces/IFolderPanelHelper";
import { getOneDriveRootDetails } from "../../../services/GraphService";
import savingLocationStructureModule from "../../../../../utilities/SavingLocationStructureModule";


export class OneDriveFolderPanelHelper extends BaseFolderPanelHelper implements IFolderPanelHelper {
    constructor(folderPanelInfo: IFolderPanelInfo,
        currentDirectory: IPageSettings,
        private addWorkingDirectory: (location: IPageSettings) => {
            type: "ADD_WORKING_DIRECTORY";
            payload: IPageSettings;
        },
        private addWorkingDirectories: (locations: IPageSettings[]) => {
            type: "ADD_WORKING_DIRECTORIES";
            payload: IPageSettings[];
        }) {

        super(folderPanelInfo, currentDirectory);
    }

    async getFolderFinalLocation(): Promise<IPageSettings> {
        return {
            ...this.getShareableProperties(),
            type: ComponentTypes.OneDriveSubFolder,
            directory: !this.currentDirectory.directory
                ? `${this.folderPanelInfo.folder.name}`
                : `${this.currentDirectory.directory}/${this.folderPanelInfo.folder.name}`,
            DocumentLibrary: "",
            sharePointListId: this.currentDirectory?.sharePointListId ?? this.folderPanelInfo.folder.sharePointListId,
        };
    }

    async save() {
        const isInLocationsComponent = this.folderPanelInfo?.locations;
        isInLocationsComponent
            ? await this.saveWhenClickingOnLocationItem()
            : this.saveWhenClickingOnPanelItemInFolders();
    }

    private saveWhenClickingOnLocationItem = async () => {
        // this.addWorkingDirectories(this.folderPanelInfo.locations);        
        const lastLocation = this.folderPanelInfo.locations[this.folderPanelInfo.locations.length - 1];
        Initiallocations.some(item => lastLocation.id === item.id)
            ? this.folderPanelInfo.saveToOneDrive(null, { id: (await getOneDriveRootDetails())?.driveId, parentId: null }, null, null, null, true)
            : this.folderPanelInfo.saveToOneDrive(this.folderPanelInfo.folder.name, lastLocation, lastLocation.directory, null, null, true);
    }

    private saveWhenClickingOnPanelItemInFolders = () => {
        let isRootDirectory = !this.currentDirectory.directory;
        const itemToAdd = {
            id: this.folderPanelInfo.folder.id,
            parentId: this.folderPanelInfo.folder.driveId,
            type: ComponentTypes.OneDriveSubFolder,
            fileTitle: this.folderPanelInfo.folder.name,
            directory: isRootDirectory ? `${this.folderPanelInfo.folder.name}` : `${this.currentDirectory.directory}/${this.folderPanelInfo.folder.name}`,
            DocumentLibrary: "",
            displayName: this.folderPanelInfo.folder.name,
            webUrl: this.currentDirectory.webUrl,
            sharePointListId: this.currentDirectory?.sharePointListId ?? this.folderPanelInfo.folder.sharePointListId,
        }
        // this.addWorkingDirectory(itemToAdd);
        // savingLocationStructureModule.addSavingLocationStructure(itemToAdd);

        this.folderPanelInfo.saveToOneDrive(this.folderPanelInfo.folder.name, itemToAdd);
    }
}
